import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// styles
import { DivStyledLoadingIcon } from './styles';

export const LoadingComponent = ({
  branding,
  className,
  themeType,
}) => (
  <DivStyledLoadingIcon
    branding={branding}
    className={classNames('loader', className)}
    themeType={themeType}
  />
);

LoadingComponent.propTypes = {
  /** sets overall branding of component or module, default='nm' */
  branding: PropTypes.oneOf(['nm', 'pcg']),
  /** optional additional className */
  className: PropTypes.string,
  /** optional themeType */
  themeType: PropTypes.oneOf(['lightTheme', 'darkTheme']),
};

LoadingComponent.defaultProps = {
  branding: 'nm',
  themeType: 'lightTheme',
};

export default LoadingComponent;
